/** Disclosure navigation. The WordPress menu remains the only source of links. */
document.addEventListener('DOMContentLoaded', () => {
    const nav = document.getElementById('roam-navigation');
    const toggle = document.querySelector('.roam-navigation-toggle');
    if (!nav || !toggle) return;

    const mobile = window.matchMedia('(max-width: 1200px)');
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const disclosures = Array.from(nav.querySelectorAll('.roam-nav-disclosure'));
    const rootItems = Array.from(nav.querySelector('.roam-nav-list').children);
    const header = nav.closest('header');
    let leaveTimer;

    const panelFor = button => document.getElementById(button.getAttribute('aria-controls'));
    function closeItem(item) {
        item.classList.remove('roam-nav-open');
        item.querySelectorAll('.roam-nav-disclosure').forEach(button => {
            button.setAttribute('aria-expanded', 'false');
            panelFor(button).hidden = true;
            button.closest('li').classList.remove('roam-nav-open');
        });
    }
    function openItem(button) {
        const item = button.closest('li');
        Array.from(item.parentElement.children).forEach(sibling => {
            if (sibling !== item) closeItem(sibling);
        });
        item.classList.add('roam-nav-open');
        button.setAttribute('aria-expanded', 'true');
        panelFor(button).hidden = false;
    }
    function closeAll() { rootItems.forEach(closeItem); }
    function setMobileOpen(open, restoreFocus = false) {
        nav.classList.toggle('roam-nav-mobile-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        document.documentElement.classList.toggle('roam-nav-lock', open);
        window.dispatchEvent(new CustomEvent('roam:navigation-toggle', { detail: { open } }));
        if (!open) closeAll();
        if (restoreFocus) toggle.focus();
    }

    disclosures.forEach(button => {
        panelFor(button).hidden = true;
        button.addEventListener('click', () => {
            if (button.getAttribute('aria-expanded') === 'true') closeItem(button.closest('li'));
            else openItem(button);
        });
        button.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                openItem(button);
                panelFor(button).querySelector('a, button')?.focus();
            }
        });
    });

    rootItems.forEach(item => {
        const button = item.querySelector(':scope > .roam-nav-disclosure');
        item.addEventListener('pointerenter', event => {
            if (mobile.matches || !hover.matches || event.pointerType === 'touch') return;
            clearTimeout(leaveTimer);
            closeAll();
            if (button) openItem(button);
        });
        item.addEventListener('pointerleave', () => {
            if (!mobile.matches && hover.matches) {
                leaveTimer = setTimeout(() => {
                    if (!item.contains(document.activeElement)) closeItem(item);
                }, 160);
            }
        });
    });

    toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        setMobileOpen(open);
        if (open) nav.querySelector('a, button')?.focus();
    });
    nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        const item = event.target.closest('.roam-nav-open');
        if (item) {
            const button = item.querySelector(':scope > .roam-nav-disclosure');
            closeItem(item);
            button?.focus();
        } else if (mobile.matches) setMobileOpen(false, true);
    });
    nav.addEventListener('focusout', () => {
        // Wait until focus has reached the next element before closing its old panel.
        setTimeout(() => {
            rootItems.forEach(item => {
                if (!item.contains(document.activeElement)) closeItem(item);
            });
        }, 0);
    });
    nav.addEventListener('click', event => {
        if (event.target.closest('a') && mobile.matches) setMobileOpen(false);
    });
    document.addEventListener('pointerdown', event => {
        if (!header.contains(event.target)) {
            closeAll();
            if (mobile.matches) setMobileOpen(false);
        }
    });
    header.addEventListener('keydown', event => {
        if (!mobile.matches || toggle.getAttribute('aria-expanded') !== 'true') return;
        if (event.key === 'Escape' && event.target === toggle) {
            setMobileOpen(false, true);
        }
        if (event.key !== 'Tab') return;
        const visible = Array.from(header.querySelectorAll('a, button')).filter(el => el.getClientRects().length);
        const first = visible[0];
        const last = visible[visible.length - 1];
        if (event.shiftKey && event.target === first) {
            event.preventDefault(); last.focus();
        } else if (!event.shiftKey && event.target === last) {
            event.preventDefault(); first.focus();
        }
    });
    mobile.addEventListener('change', () => setMobileOpen(false));
    window.addEventListener('pagehide', () => setMobileOpen(false));
    nav.classList.add('roam-nav-ready');
});
